import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { MoneyInputCore } from '../MoneyInput.Core/MoneyInput.Core.es.js';

const MoneyInputCustom = /*#__PURE__*/ forwardRef(({ currencyConfig, // For custom currency configurations, default to hiding symbol
disableCurrencySymbol = true, ...props }, ref)=>jsx(MoneyInputCore, {
        ref: ref,
        currencyConfig: currencyConfig,
        disableCurrencySymbol: disableCurrencySymbol,
        ...props
    }));
MoneyInputCustom.displayName = 'MoneyInput.Custom';

export { MoneyInputCustom, MoneyInputCustom as default };
//# sourceMappingURL=MoneyInput.Custom.es.js.map
